// src/api/carApi.js
import api from './index';


export const getGptCarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/gptCarpage_gpt_submai', params, config);
};

// 新线路 Plus 车队使用独立接口，老线路使用 getGptFullCarList。
export const getGptPlusCarList = (params = {}, config = {}) => {
  return api.post('/testapi/gateway/new_gateway_controller/frontend-api/gptCarpage_gpt_submain', params, config);
};

// GPT 车队全集查询：使用排序和分页参数，返回完整节点集合（普通号和 Plus 号）
export const getGptFullCarList = (params = {}, config = {}) => {
  return api.post(
    '/testapi/gateway/new_gateway_controller/frontend-api/gptCarpage_aimonkey_submain',
    {
      order: 'sort',
      page: 1,
      size: 1000,
      sort: 'desc',
      ...params,
    },
    config
  );
};


export const getGptAPICarList = (params = {}, config = {}) => {
  return api.post('/testapi/gateway/new_gateway_controller/frontend-api/gpt_gpt_api_Carpage_gpt_submai', params, config);
};

export const getGrokCarList = (params = {}, config = {}) => {
  return api.post('/testapi/gateway/new_gateway_controller/frontend-api/grokCarpage_grok_submain', params, config);
};


export const getSoraCarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/soraCarpage_sora_submain', params, config);
  };


export const getMJCarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/mjCarpage_mj_submain', params, config);
};


export const getCCarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/claudeCarpage_claude_submain', params, config);
};

export const getClaudeV2CarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/claudeCarpage_aimonkeyVip_submain', params, config);
};

export const getGeminiCarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/geminiCarpage_gemini_submain', params, config);
};
